import styled from "styled-components";

export const Form = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: ${({ theme }) => theme.shadows.tile};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`;

export const Input = styled.input`
  padding: 12px 16px;
  border: 1.5px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  color: ${({ theme }) => theme.colors.text};
  background: ${({ disabled }) => (disabled ? "#f0f0f5" : "white")};
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #3182ce;
    box-shadow: 0 0 0 2px rgba(44, 82, 130, 0.1);
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const HelpText = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.secondary};
  font-style: italic;
`;

export const SaveButton = styled.button`
  padding: 12px 20px;
  background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(44, 82, 130, 0.4);
  }

  &:active {
    transform: scale(0.98);
  }
`;
